import '../styles/basic.css';

export function Divider() {
  return (
    <div className='divider'/>
  );
}
